var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmileinline = function SvgSmileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1155,
    height: 1018,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#smile_inline_svg__a)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 737.5,
    cy: 153.5,
    r: 53.5,
    fill: "url(#smile_inline_svg__b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#smile_inline_svg__c)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431.5,
    cy: 153.5,
    r: 53.5,
    fill: "url(#smile_inline_svg__d)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#smile_inline_svg__e)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#smile_inline_svg__f)",
    d: "M577.5 743c263.716 0 477.5-567.092 477.5-303.376s-213.784 477.5-477.5 477.5S100 703.34 100 439.624 313.784 743 577.5 743Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smile_inline_svg__b",
    x1: 682.997,
    x2: 791.017,
    y1: 148.346,
    y2: 149.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smile_inline_svg__d",
    x1: 376.997,
    x2: 485.017,
    y1: 148.346,
    y2: 149.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smile_inline_svg__f",
    x1: 544.824,
    x2: 551.077,
    y1: 813.577,
    y2: -150.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "smile_inline_svg__a",
    width: 307,
    height: 307,
    x: 584,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_646_583",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "smile_inline_svg__c",
    width: 307,
    height: 307,
    x: 278,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_646_583",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "smile_inline_svg__e",
    width: 1155,
    height: 747.433,
    x: 0,
    y: 269.691,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_646_583",
    stdDeviation: 50
  })))));
};
export default SvgSmileinline;